/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Per_MonthInputs */

const en_plan_per_month = /** @type {(inputs: Plan_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/month`)
};

const es_plan_per_month = /** @type {(inputs: Plan_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mes`)
};

/**
* | output |
* | --- |
* | "/month" |
*
* @param {Plan_Per_MonthInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_per_month = /** @type {((inputs?: Plan_Per_MonthInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Per_MonthInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_per_month(inputs)
	return en_plan_per_month(inputs)
});